import Vue from 'vue'
import conversations from './APIConversationRepository'
import LaravelEchoRepository from './LaravelEchoRepository'

import VueLetterAvatar from 'vue-letter-avatar'
Vue.use(VueLetterAvatar)

const moment = require('moment')
require('moment/locale/it')
Vue.use(require('vue-moment'), {
    moment
})

export default { 
  
  mounted() {

    this.$root.$on("resetSearch", message => {      
      this.resetSearch()
    }),

    this.$root.$on("changeLastConversationInList", function(message,time){   
      
      var i= this.getConvesationIndexByID(this.conversationSelected)   
      this.conversations[i].updated_at = time
      this.conversations[i].latest_message.text = message;
    }.bind(this)),
    
    this.$root.$on("loadConversationList", function(type,projectId,conversationid){   
      if(projectId) this.currentProjectID = projectId           
      if(type) this.currentType = type
      this.loadConversationList(type,projectId,conversationid)
    }.bind(this)),

    this.$root.$on("addNotifyFromServer",  function(conversationID){         
      var i= this.getConvesationIndexByID(conversationID)                        
      if(this.conversations[i].manual) this.conversations[i].has_been_updated =true   
      if(this.conversations[i].manual) this.conversations[i].updated_count ++
                     
    }.bind(this)),

    this.$root.$on("checkConversationList",  function(conversationID){         
      var i= this.getConvesationIndexByID(conversationID)                                   
      if (i==-1) this.loadConversationList(this.currentType,this.currentProjectID,this.conversationSelected)                  
    }.bind(this))    

    
    
  },
  methods: {
     fetch (type='bot',search='',conversationID=0) {
      
       this.currentType= type                  
                           
       return new Promise((resolve) =>{
        //this.isLoading = true           
                                  
            let params = {
              'filter': {
                'type': this.currentType
              },
              'sort': '-updated_at'
            }

            if (search!='') params['filter']['search'] = search             
            conversations.getConversations(this.currentProjectID,params).then((res)=>{  

                if (res.status !== 200){
                  alert("Il progetto non esiste oppure non hai i privilegi per gestirlo.")
                  return
                }
                                        
                //this.isLoading = false                                
                if (typeof(res.response)!="undefined"){                  
                   this.conversations = res.response.data                                    

                   if ( type=='mine'){
                    this.conversations.forEach(function(x) { 
                      if (! LaravelEchoRepository.ifChannelIsAlreadyOpen(x.id)) LaravelEchoRepository.listenForConversationUpdate(x.id,this.$root) 
                    }.bind(this))
                    
                   } 
                                   
                  if (this.conversations.length>0){        
                                                                                                    
                    if (conversationID==0){
                        this.loadFirstConversation()
                        resolve(true)
                    } 
                    
                    // se è cambiato la conversazione la ricarico  
                    if (conversationID != this.conversationSelected || this.searchstring!=''){                                                                                            
                        this.conversationSelected = conversationID 
                        var i= this.getConvesationIndexByID(this.conversationSelected)      
                        // se non trovato seleziona la prima della lista                    
                        if (i==-1) i=0
                        this.changeMsg(this.conversations[i])                                                    
                        resolve(true)                                              
                    }
                    

                  }else{
                    this.$root.$emit("deleteMsgContainer")
                    resolve(true)
                  }
                }  

                
            })  

        })     
    },
    loadFirstConversation(){
      this.conversationSelected = this.conversations[0].id 
      this.changeMsg(this.conversations[0])
    },
    getConvesationIndexByID(conversationID){
      var i=-1
      if (conversationID!=null){                            
          this.conversations.forEach(function(x, index) {      
            if (x.id == conversationID) {      
              i = index        
              return i               
            }
          })                                                                             
      }
      return i 
    },
    dateToFromNowDaily( myDate ) {
                
        var hour = Vue.prototype.$moment(myDate).format("HH:mm")        
        
        
        var date =  Vue.prototype.$moment( myDate ).calendar( null, {            
            lastWeek:  function () {
                hour=''
                return "[ultima settimana]"
            },
            lastDay:  '[ieri]',
            sameDay:  '[oggi]',
            nextDay:  '[domani]',
            nextWeek: '[prossima sett.]',                    

            sameElse: function () {
                hour=''
                return "[" + Vue.prototype.$moment(myDate).format("DD MMM") + "]"
            }
        })

        return date + " " +  hour         
    },    
    changeMsg(conversation) {

          this.previousConversationSelected = this.conversationSelected
          this.conversationSelected = conversation.id    
          
          let previuosConversationObj = document.getElementById('cid_' + this.previousConversationSelected)
          if(previuosConversationObj){
            let ismanual = previuosConversationObj.getAttribute("attr-manual")            
            if (ismanual!= "true") LaravelEchoRepository.leaveChannel(this.previousConversationSelected)     
          }  

          if (! LaravelEchoRepository.ifChannelIsAlreadyOpen(this.conversationSelected)) LaravelEchoRepository.listenForConversationUpdate(this.conversationSelected,this.$root) 
        
          var i= this.getConvesationIndexByID(this.conversationSelected)                        
          this.conversations[i].has_been_updated =false
          this.conversations[i].updated_count =0

          this.$root.$emit("changeMsgContainer", conversation,this.searchstring)       
          this.$root.$emit("changeMessageRoute", JSON.parse(localStorage.getItem('lastProjectSelected')).id,this.conversationSelected)          
          this.changeUser(conversation)
    },
    changeUser(conversation) {        
          this.$root.$emit("changeUserContainer", conversation)                   
    },
    searchConversation(){                          
      if (this.timeout) clearTimeout(this.timeout) 
          this.timeout = setTimeout(() => {
          if (this.searchstring.length>2) this.fetch(this.currentType,this.searchstring,this.conversationSelected)  
      }, 1000)
    },    
    resetSearch(){
        this.searchstring=''        
        this.loadConversationList(this.currentType)      
        document.querySelectorAll(".highlightText").forEach(function(userItem) {          
          userItem.classList.remove("highlightText")
        })
    },
    loadConversationList(type=this.currentType,projectid,conversationID=0){                          
        this.fetch(type,'',conversationID)
    }
  }  
}